import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {Observable} from 'rxjs/Observable';
import {VehicleAdminRow} from '../../../_models/vehicle';
import {VehiclesService} from '../../../_services/vehicles.service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {catchError, finalize} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import { PaginationParams } from '../../../_models/generic';

export class VehicleDataSource implements DataSource<VehicleAdminRow> {

    private vehiclesSubject = new BehaviorSubject<VehicleAdminRow[]>([]);

    private loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this.loadingSubject.asObservable();
    public paginatorTotalCount: number;

    constructor(private vehicleService: VehiclesService) {

    }

    loadAdminVehicles(params: PaginationParams) {
        this.loadingSubject.next(true);

        this.vehicleService.getAdminCustomerVehicles(params).pipe(
                catchError(() => of([])),
                finalize(() => this.loadingSubject.next(false))
            )
            .subscribe(vehicles => {
                console.log('find vehicles service  in Datasource: ', vehicles);
                this.paginatorTotalCount = vehicles['count'];
                this.vehiclesSubject.next(vehicles['results']);
            });

    }

    findById(id: number): VehicleAdminRow | null {
        const vehicles = this.vehiclesSubject.value;
        return vehicles.find(rep => rep.id === id) || null;
    }

    connect(collectionViewer: CollectionViewer): Observable<VehicleAdminRow[]> {
        console.log("Connecting Vehicles Admin data source");
        return this.vehiclesSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.vehiclesSubject.complete();
        this.loadingSubject.complete();
    }

}




// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/dl-multi-select-vehicles/vehicles.datasource.ts